import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_apiKey,
  authDomain: process.env.VUE_APP_FIREBASE_authDomain,
  databaseURL: process.env.VUE_APP_FIREBASE_databaseURL,
  projectId: process.env.VUE_APP_FIREBASE_projectId,
  storageBucket: process.env.VUE_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.VUE_APP_FIREBASE_messagingSenderId,
  appId: process.env.VUE_APP_FIREBASE_appId,
};

firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();

// collection references
const jobsCollection = db.collection('jobs');
const depotsCollection = db.collection('depots');
const storesCollection = db.collection('stores');
const routesCollection = db.collection('routes');
const palletCollection = db.collection('pallets');
const productCollection = db.collection('products');
const retailerCollection = db.collection('retailers');
const suppliersCollection = db.collection('suppliers');
const solverStatusCollection = db.collection('solver_status');
const purchaseOrdersCollection = db.collection('purchase_orders');
const deliveryRequestsCollection = db.collection('delivery_requests');
const purchaseOrderLinesCollection = db.collection('purchase_order_lines');
const purchaseOrderPalletsCollection = db.collection('purchase_order_pallets');

const secureAuthSupplier = (query) => query.where('supplier', '==', suppliersCollection.doc(auth.currentUser.uid));

// export utils/refs
export {
  db,
  auth,
  jobsCollection,
  depotsCollection,
  storesCollection,
  routesCollection,
  palletCollection,
  productCollection,
  retailerCollection,
  suppliersCollection,
  solverStatusCollection,
  purchaseOrdersCollection,
  deliveryRequestsCollection,
  purchaseOrderLinesCollection,
  purchaseOrderPalletsCollection,
  secureAuthSupplier,
};
